import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/table';
import { CdkTable, CDK_TABLE, _COALESCED_STYLE_SCHEDULER, _CoalescedStyleScheduler, CdkTableModule, CDK_TABLE_TEMPLATE, CdkCellDef, CdkHeaderCellDef, CdkFooterCellDef, CdkColumnDef, CdkHeaderCell, CdkFooterCell, CdkCell, CdkHeaderRowDef, CdkFooterRowDef, CdkRowDef, CdkHeaderRow, CDK_ROW_TEMPLATE, CdkFooterRow, CdkRow, CdkNoDataRow, CdkTextColumn } from '@angular/cdk/table';
import { _VIEW_REPEATER_STRATEGY, _DisposeViewRepeaterStrategy } from '@angular/cdk/collections';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
/* eslint-disable max-len */
/**
 * Table Component
 *
 * @description The tree component is a dumb component that is used to display data in a tabular format.
 * @example
 * <!-- rs-doc {link: 'Example with two columns and two rows'} -->
 * <table style="width: 100%; table-layout: fixed;" rs-table [dataSource]="[{first: 'brandon', last: 'staley'}, {first: 'moira', last: 'rose'}, {first: 'david', last: 'rose'}, {first: 'alexis', last: 'rose'}, {first: 'johnny', last: 'rose'}]">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell style="word-break: break-all; max-width: 200px;" *rsCellDef="let element"> 99739,99918,99929,99501,99732,99733,99730,99830,99736,99725,99737,99726,99503,99734,99504,99901,99724,99729,99829,99738,99928,99727 </td>
 *  </ng-container>
 * <ng-container rsColumnDef="chip">
 *   <th rs-header-cell *rsHeaderCellDef> Chip </th>
 *   <td rs-cell *rsCellDef="let element"> <rs-chip type="success">Active</rs-chip> </td>
 *  </ng-container>
 * <ng-container rsColumnDef="action">
 *   <th rs-header-cell *rsHeaderCellDef style="width: 20px;"></th>
 *   <td rs-cell *rsCellDef="let element" style="width: 20px;">
 *  <svg [rsMenuTrigger]="abc" viewBox="0 0 24 24" fill="#000"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
 *  </td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'chip' , 'action']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'chip', 'action'];"></tr>
 * </table>
 * <rs-menu #abc>
 *  <button rs-menu-item>Testing</button>
 *  <button rs-menu-item>Testing 2</button>
 * </rs-menu>
 * @example
 * <!-- rs-doc {link: 'Example with sticky columns'} -->
 * <div style="width: 400px; height: 400px; overflow: auto;">
 * <table style="width: 600px" rs-table [dataSource]="[{first: 'a', last: 'b', phone: '111-111-1111'}, {first: 'b', last: 'c', phone: '121-111-1111'}, {first: 'c', last: 'd', phone: '121-111-1111'}, {first: 'd', last: 'e', phone: '121-111-1111'}, {first: 'e', last: 'f', phone: '121-111-1111'}, {first: 'f', last: 'g', phone: '121-111-1111'}, {first: 'g', last: 'h', phone: '121-111-1111'}, {first: 'h', last: 'i', phone: '121-111-1111'}, {first: 'i', last: 'j', phone: '121-111-1111'}, {first: 'j', last: 'k', phone: '121-111-1111'}, {first: 'k', last: 'l', phone: '121-111-1111'}, {first: 'l', last: 'm', phone: '121-111-1111'}, {first: 'm', last: 'n', phone: '121-111-1111'}, {first: 'n', last: 'o', phone: '121-111-1111'}]">
 *  <ng-container rsColumnDef="first" sticky>
 *   <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="phone">
 *   <th rs-header-cell *rsHeaderCellDef> Phone </th>
 *   <td rs-cell *rsCellDef="let element"> <rs-text-mask color="secondary" displayDirection="end" [displayTextLength]=4 [value]="123456789"></rs-text-mask></td>
 *  </ng-container>
 * <ng-container rsColumnDef="action" stickyEnd>
 *   <th rs-header-cell *rsHeaderCellDef style="width: 20px;"></th>
 *   <td rs-cell *rsCellDef="let element" style="width: 20px;">
 *  <svg [rsMenuTrigger]="abc" viewBox="0 0 24 24" fill="#000"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
 *  </td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'phone', 'last', 'phone', 'action']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'phone', 'last', 'phone', 'action'];"></tr>
 * </table>
 * <rs-menu #abc>
 *  <button rs-menu-item>Testing</button>
 *  <button rs-menu-item>Testing 2</button>
 * </rs-menu>
 * </div>
 * @example
 * <!-- rs-doc {link: 'Example using flex'} -->
 * <rs-table rs-table [dataSource]="[{first: 'brandon', last: 'staley'}, {first: 'moira', last: 'rose'}]">
 *  <ng-container rsColumnDef="first">
 *   <rs-header-cell style="flex: 1" *rsHeaderCellDef> First Name </rs-header-cell>
 *   <rs-cell style="flex: 1" *rsCellDef="let element"> {{element.first}} </rs-cell>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <rs-header-cell style="flex: 1" *rsHeaderCellDef> Last Name </rs-header-cell>
 *   <rs-cell style="flex: 1" *rsCellDef="let element"> {{element.last}} </rs-cell>
 *  </ng-container>
 *  <rs-header-row style="display:flex" *rsHeaderRowDef="['first', 'last']"></rs-header-row>
 *  <rs-row style="display:flex" *rsRowDef="let row; columns: ['first', 'last'];"></rs-row>
 * </rs-table>
 */
class TableComponent extends CdkTable {
    constructor() {
        super(...arguments);
        /**
         * dataSource
         *
         * @type {CdkTableDataSourceInput<T>}
         * @description The table's source of data, which can be provided in three ways (in order of complexity):
         *   - Simple data array (each object represents one table row)
         *   - Stream that emits a data array each time the array changes
         *   - `DataSource` object that implements the connect/disconnect interface.
         *
         * If a data array is provided, the table must be notified when the array's objects are
         * added, removed, or moved. This can be done by calling the `renderRows()` function which will
         * render the diff since the last table render. If the data array reference is changed, the table
         * will automatically trigger an update to the rows.
         *
         * When providing an Observable stream, the table will trigger an update automatically when the
         * stream emits a new array of data.
         *
         * Finally, when providing a `DataSource` object, the table will use the Observable stream
         * provided by the connect function and trigger updates when that stream emits new data array
         * values. During the table's ngOnDestroy or when the data source is removed from the table, the
         * table will call the DataSource's `disconnect` function (may be useful for cleaning up any
         * subscriptions registered during the connect process).
         * @kind Input
         */
        this.__doc_only_dataSource = undefined;
        /**
         * fixedLayout
         *
         * @type {boolean}
         * @description Whether to use a fixed table layout. Enabling this option will enforce consistent column widths and optimize rendering sticky styles for native tables. No-op for flex tables.
         * @kind Input
         */
        this.__doc_only_fixedLayout = false;
        /**
         * multiTemplateDataRows
         *
         * @type {boolean}
         * @description Whether to allow multiple rows per data object by evaluating which rows evaluate their 'when' predicate to true. If multiTemplateDataRows is false, which is the default value, then each dataobject will render the first row that evaluates its when predicate to true, in the order defined in the table, or otherwise the default row which does not have a when predicate.
         * @kind Input
         */
        this.__doc_only_multiTemplateDataRows = false;
        /**
         * trackBy
         *
         * @type {TrackByFunction<T>}
         * @description Tracking function that will be used to check the differences in data changes. Used similarly to ngFor trackBy function. Optimize row operations by identifying a row based on its data relative to the function to know if a row should be added/removed/moved. Accepts a function that takes two parameters, index and item.
         * @kind Input
         */
        this.__doc_only_trackBy = undefined;
        /* Overrides the sticky CSS class set by the `CdkTable`. */
        this.stickyCssClass = 'rs-table-sticky';
        /* Overrides the need to add position: sticky on every sticky cell element in `CdkTable`. */
        this.needsPositionStickyOnElement = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: TableComponent, isStandalone: true, selector: "rs-table, table[rs-table]", host: { properties: { "class.rs-table-fixed-layout": "fixedLayout" }, classAttribute: "rs-table" }, providers: [
            { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
            { provide: CdkTable, useExisting: TableComponent },
            { provide: CDK_TABLE, useExisting: TableComponent },
            { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
        ], exportAs: ["rsTable"], usesInheritance: true, ngImport: i0, template: "\n  <ng-content select=\"caption\"/>\n  <ng-content select=\"colgroup, col\"/>\n\n  <!--\n    Unprojected content throws a hydration error so we need this to capture it.\n    It gets removed on the client so it doesn't affect the layout.\n  -->\n  @if (_isServer) {\n    <ng-content/>\n  }\n\n  @if (_isNativeHtmlTable) {\n    <thead role=\"rowgroup\">\n      <ng-container headerRowOutlet/>\n    </thead>\n    <tbody role=\"rowgroup\">\n      <ng-container rowOutlet/>\n      <ng-container noDataRowOutlet/>\n    </tbody>\n    <tfoot role=\"rowgroup\">\n      <ng-container footerRowOutlet/>\n    </tfoot>\n  } @else {\n    <ng-container headerRowOutlet/>\n    <ng-container rowOutlet/>\n    <ng-container noDataRowOutlet/>\n    <ng-container footerRowOutlet/>\n  }\n", isInline: true, styles: ["rs-table{display:block}rs-header-row{min-height:56px;background-color:#fff;border-top:solid 1px rgb(221,222,222);border-bottom:solid 1px rgb(221,222,222)}rs-row{min-height:48px}rs-row:nth-child(odd) rs-cell{background-color:#f2f5f7}rs-row:nth-child(2n) rs-cell{background-color:#fff}rs-footer-row{min-height:48px}rs-footer-row rs-cell{background-color:#fff;border-top:solid 1px rgb(221,222,222)}rs-row,rs-header-row,rs-footer-row{display:flex;align-items:center;box-sizing:border-box}rs-row:after,rs-header-row:after,rs-footer-row:after{display:inline-block;min-height:inherit;content:\"\"}rs-cell:first-of-type,rs-header-cell:first-of-type,rs-footer-cell:first-of-type{padding-left:24px}[dir=rtl] rs-cell:first-of-type:not(:only-of-type),[dir=rtl] rs-header-cell:first-of-type:not(:only-of-type),[dir=rtl] rs-footer-cell:first-of-type:not(:only-of-type){padding-left:0;padding-right:24px}rs-cell:last-of-type,rs-header-cell:last-of-type,rs-footer-cell:last-of-type{padding-right:24px}[dir=rtl] rs-cell:last-of-type:not(:only-of-type),[dir=rtl] rs-header-cell:last-of-type:not(:only-of-type),[dir=rtl] rs-footer-cell:last-of-type:not(:only-of-type){padding-right:0;padding-left:24px}rs-cell,rs-header-cell,rs-footer-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}table.rs-table{border-spacing:0}tr.rs-header-row{height:56px}tr.rs-row{height:48px}tr.rs-row:nth-child(odd) td{background-color:#f2f5f7}tr.rs-row:nth-child(2n) td{background-color:#fff}tr.rs-footer-row{height:48px}tr.rs-footer-row td{background-color:#fff;border-top:solid 1px rgb(221,222,222)}th.rs-header-cell{text-align:left;background-color:#fff;border-top:solid 1px rgb(221,222,222);border-bottom:solid 1px rgb(221,222,222)}[dir=rtl] th.rs-header-cell{text-align:right}th.rs-header-cell,td.rs-cell,td.rs-footer-cell{padding:0}th.rs-header-cell:first-of-type,td.rs-cell:first-of-type,td.rs-footer-cell:first-of-type{padding-left:24px}[dir=rtl] th.rs-header-cell:first-of-type:not(:only-of-type),[dir=rtl] td.rs-cell:first-of-type:not(:only-of-type),[dir=rtl] td.rs-footer-cell:first-of-type:not(:only-of-type){padding-left:0;padding-right:24px}th.rs-header-cell:last-of-type,td.rs-cell:last-of-type,td.rs-footer-cell:last-of-type{padding-right:24px}[dir=rtl] th.rs-header-cell:last-of-type:not(:only-of-type),[dir=rtl] td.rs-cell:last-of-type:not(:only-of-type),[dir=rtl] td.rs-footer-cell:last-of-type:not(:only-of-type){padding-right:0;padding-left:24px}.rs-table-sticky{position:-webkit-sticky;position:sticky}.rs-table-fixed-layout{table-layout:fixed}\n"], dependencies: [{ kind: "ngmodule", type: CdkTableModule }, { kind: "directive", type: i1.DataRowOutlet, selector: "[rowOutlet]" }, { kind: "directive", type: i1.HeaderRowOutlet, selector: "[headerRowOutlet]" }, { kind: "directive", type: i1.FooterRowOutlet, selector: "[footerRowOutlet]" }, { kind: "directive", type: i1.NoDataRowOutlet, selector: "[noDataRowOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'rs-table, table[rs-table]', exportAs: 'rsTable', template: CDK_TABLE_TEMPLATE, host: {
                        class: 'rs-table',
                        '[class.rs-table-fixed-layout]': 'fixedLayout',
                    }, providers: [
                        { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
                        { provide: CdkTable, useExisting: TableComponent },
                        { provide: CDK_TABLE, useExisting: TableComponent },
                        { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, standalone: true, imports: [CdkTableModule], styles: ["rs-table{display:block}rs-header-row{min-height:56px;background-color:#fff;border-top:solid 1px rgb(221,222,222);border-bottom:solid 1px rgb(221,222,222)}rs-row{min-height:48px}rs-row:nth-child(odd) rs-cell{background-color:#f2f5f7}rs-row:nth-child(2n) rs-cell{background-color:#fff}rs-footer-row{min-height:48px}rs-footer-row rs-cell{background-color:#fff;border-top:solid 1px rgb(221,222,222)}rs-row,rs-header-row,rs-footer-row{display:flex;align-items:center;box-sizing:border-box}rs-row:after,rs-header-row:after,rs-footer-row:after{display:inline-block;min-height:inherit;content:\"\"}rs-cell:first-of-type,rs-header-cell:first-of-type,rs-footer-cell:first-of-type{padding-left:24px}[dir=rtl] rs-cell:first-of-type:not(:only-of-type),[dir=rtl] rs-header-cell:first-of-type:not(:only-of-type),[dir=rtl] rs-footer-cell:first-of-type:not(:only-of-type){padding-left:0;padding-right:24px}rs-cell:last-of-type,rs-header-cell:last-of-type,rs-footer-cell:last-of-type{padding-right:24px}[dir=rtl] rs-cell:last-of-type:not(:only-of-type),[dir=rtl] rs-header-cell:last-of-type:not(:only-of-type),[dir=rtl] rs-footer-cell:last-of-type:not(:only-of-type){padding-right:0;padding-left:24px}rs-cell,rs-header-cell,rs-footer-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}table.rs-table{border-spacing:0}tr.rs-header-row{height:56px}tr.rs-row{height:48px}tr.rs-row:nth-child(odd) td{background-color:#f2f5f7}tr.rs-row:nth-child(2n) td{background-color:#fff}tr.rs-footer-row{height:48px}tr.rs-footer-row td{background-color:#fff;border-top:solid 1px rgb(221,222,222)}th.rs-header-cell{text-align:left;background-color:#fff;border-top:solid 1px rgb(221,222,222);border-bottom:solid 1px rgb(221,222,222)}[dir=rtl] th.rs-header-cell{text-align:right}th.rs-header-cell,td.rs-cell,td.rs-footer-cell{padding:0}th.rs-header-cell:first-of-type,td.rs-cell:first-of-type,td.rs-footer-cell:first-of-type{padding-left:24px}[dir=rtl] th.rs-header-cell:first-of-type:not(:only-of-type),[dir=rtl] td.rs-cell:first-of-type:not(:only-of-type),[dir=rtl] td.rs-footer-cell:first-of-type:not(:only-of-type){padding-left:0;padding-right:24px}th.rs-header-cell:last-of-type,td.rs-cell:last-of-type,td.rs-footer-cell:last-of-type{padding-right:24px}[dir=rtl] th.rs-header-cell:last-of-type:not(:only-of-type),[dir=rtl] td.rs-cell:last-of-type:not(:only-of-type),[dir=rtl] td.rs-footer-cell:last-of-type:not(:only-of-type){padding-right:0;padding-left:24px}.rs-table-sticky{position:-webkit-sticky;position:sticky}.rs-table-fixed-layout{table-layout:fixed}\n"] }]
        }] });

/**
 * Cell definition for the rs-table.
 *
 * @description captures the template of a column's data row cell as well as cell-specific properties.
 * @ignore
 */
class CellDefComponent extends CdkCellDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CellDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: CellDefComponent, isStandalone: true, selector: "[rsCellDef]", providers: [{ provide: CdkCellDef, useExisting: CellDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CellDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsCellDef]',
                    providers: [{ provide: CdkCellDef, useExisting: CellDefComponent }],
                    standalone: true
                }]
        }] });
/**
 * Header cell definition for the rs-table.
 *
 * @description Captures the template of a column's header cell and as well as cell-specific properties.
 * @ignore
 */
class HeaderCellDefComponent extends CdkHeaderCellDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderCellDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: HeaderCellDefComponent, isStandalone: true, selector: "[rsHeaderCellDef]", providers: [{ provide: CdkHeaderCellDef, useExisting: HeaderCellDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderCellDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsHeaderCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: HeaderCellDefComponent }],
                    standalone: true
                }]
        }] });
/**
 * Footer cell definition for the rs-table.
 *
 * @description Captures the template of a column's footer cell and as well as cell-specific properties.
 * @ignore
 */
class FooterCellDefComponent extends CdkFooterCellDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterCellDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: FooterCellDefComponent, isStandalone: true, selector: "[rsFooterCellDef]", providers: [{ provide: CdkFooterCellDef, useExisting: FooterCellDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterCellDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsFooterCellDef]',
                    providers: [{ provide: CdkFooterCellDef, useExisting: FooterCellDefComponent }],
                    standalone: true
                }]
        }] });
/**
 * Column definition for the rs-table.
 *
 * @description Defines a set of cells available for a table column.
 * @ignore
 */
class ColumnDefComponent extends CdkColumnDef {
    // Unique name for this column.
    get name() { return this._name; }
    set name(name) { this._setNameInput(name); }
    /*
     * Add "rs-column-" prefix in addition to "cdk-column-" prefix.
     * In the future, this will only add "rs-column-" and columnCssClassName
     * will change from type string[] to string.
     * @docs-private
     */
    _updateColumnCssClassName() {
        super._updateColumnCssClassName();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this._columnCssClassName.push(`rs-column-${this.cssClassFriendlyName}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ColumnDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: ColumnDefComponent, isStandalone: true, selector: "[rsColumnDef]", inputs: { sticky: "sticky", name: ["rsColumnDef", "name"] }, providers: [
            { provide: CdkColumnDef, useExisting: ColumnDefComponent },
            { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: ColumnDefComponent }
        ], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ColumnDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsColumnDef]',
                    inputs: ['sticky'],
                    providers: [
                        { provide: CdkColumnDef, useExisting: ColumnDefComponent },
                        { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: ColumnDefComponent }
                    ],
                    standalone: true,
                }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['rsColumnDef']
            }] } });
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
/* eslint-disable max-len */
/**
 * Header cell
 *
 * @ignore
 */
class HeaderCellComponent extends CdkHeaderCell {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderCellComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: HeaderCellComponent, isStandalone: true, selector: "rs-header-cell, th[rs-header-cell]", host: { attributes: { "role": "columnheader" }, classAttribute: "rs-header-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderCellComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: 'rs-header-cell, th[rs-header-cell]',
                    host: {
                        class: 'rs-header-cell',
                        role: 'columnheader',
                    },
                    standalone: true,
                }]
        }] });
/**
 * Footer cell
 *
 * @ignore
 */
class FooterCellComponent extends CdkFooterCell {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterCellComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: FooterCellComponent, isStandalone: true, selector: "rs-footer-cell, td[rs-footer-cell]", host: { attributes: { "role": "gridcell" }, classAttribute: "rs-footer-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterCellComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: 'rs-footer-cell, td[rs-footer-cell]',
                    host: {
                        class: 'rs-footer-cell',
                        role: 'gridcell',
                    },
                    standalone: true,
                }]
        }] });
/**
 * Cell template
 *
 * @ignore
 */
class CellComponent extends CdkCell {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CellComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: CellComponent, isStandalone: true, selector: "rs-cell, td[rs-cell]", host: { attributes: { "role": "gridcell" }, classAttribute: "rs-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CellComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: 'rs-cell, td[rs-cell]',
                    host: {
                        class: 'rs-cell',
                        role: 'gridcell',
                    },
                    standalone: true,
                }]
        }] });

/**
 * Header row definition for the rs-table.
 *
 * @description Captures the header row's template and other header properties such as the columns to display.
 * @ignore
 */
class HeaderRowDefComponent extends CdkHeaderRowDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderRowDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: HeaderRowDefComponent, isStandalone: true, selector: "[rsHeaderRowDef]", inputs: { columns: ["rsHeaderRowDef", "columns"], sticky: ["rsHeaderRowDefSticky", "sticky"] }, providers: [{ provide: CdkHeaderRowDef, useExisting: HeaderRowDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderRowDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: HeaderRowDefComponent }],
                    inputs: ['columns: rsHeaderRowDef', 'sticky: rsHeaderRowDefSticky'],
                    standalone: true,
                }]
        }] });
/**
 * Footer row definition for the rs-table.
 *
 * @description Captures the footer row's template and other footer properties such as the columns to display.
 * @ignore
 */
class FooterRowDefComponent extends CdkFooterRowDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterRowDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: FooterRowDefComponent, isStandalone: true, selector: "[rsFooterRowDef]", inputs: { columns: ["rsFooterRowDef", "columns"], sticky: ["rsFooterRowDefSticky", "sticky"] }, providers: [{ provide: CdkFooterRowDef, useExisting: FooterRowDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterRowDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsFooterRowDef]',
                    providers: [{ provide: CdkFooterRowDef, useExisting: FooterRowDefComponent }],
                    inputs: ['columns: rsFooterRowDef', 'sticky: rsFooterRowDefSticky'],
                    standalone: true,
                }]
        }] });
/**
 * Data row definition for the rs-table.
 *
 * @description Captures the data row's template and other properties such as the columns to display and a when predicate that describes when this row should be used.
 * @ignore
 */
class RowDefComponent extends CdkRowDef {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RowDefComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: RowDefComponent, isStandalone: true, selector: "[rsRowDef]", inputs: { columns: ["rsRowDefColumns", "columns"], when: ["rsRowDefWhen", "when"] }, providers: [{ provide: CdkRowDef, useExisting: RowDefComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RowDefComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: '[rsRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: RowDefComponent }],
                    inputs: ['columns: rsRowDefColumns', 'when: rsRowDefWhen'],
                    standalone: true,
                }]
        }] });
/**
 * Header template
 *
 * @description container that contains the cell outlet. Adds the right class and role.
 * @example
 * <!-- rs-doc {link: 'Example with sticky header', data: { ngOnInit: (function(){this.orig = [...this.source];}), filterIt: (function(){ let o = [...this.orig];  o = (this.filterState ? o.filter(x => x.first.includes(this.filterState)) : o); o = this.sortIt(o); this.source = o; }), filterState: '', sortIt: (function(data){return (this.sortState === 'none' ? data : data.sort((a,b) => this.sortState === 'asc' ? a.first.localeCompare(b.first) : b.first.localeCompare(a.first)));}), getSortState: (function() { this.sortState = (this.sortState === 'none' ? 'asc' : (this.sortState === 'asc' ? 'des' : 'none')); this.filterIt(); }), shouldShowSort: false, sortState: 'none', source: [{first: 'a', last: 'b', phone: '111-111-1111'}, {first: 'b', last: 'c', phone: '121-111-1111'}, {first: 'c', last: 'd', phone: '121-111-1111'}, {first: 'd', last: 'e', phone: '121-111-1111'}, {first: 'e', last: 'f', phone: '121-111-1111'}, {first: 'f', last: 'g', phone: '121-111-1111'}, {first: 'g', last: 'h', phone: '121-111-1111'}, {first: 'h', last: 'i', phone: '121-111-1111'}, {first: 'i', last: 'j', phone: '121-111-1111'}, {first: 'j', last: 'k', phone: '121-111-1111'}, {first: 'k', last: 'l', phone: '121-111-1111'}, {first: 'l', last: 'm', phone: '121-111-1111'}, {first: 'm', last: 'n', phone: '121-111-1111'}, {first: 'n', last: 'o', phone: '121-111-1111'}]}} -->
 * <div style="height: 400px; overflow: auto;">
 * <table style="width: 100%" rs-table [dataSource]="source">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef (mouseenter)="shouldShowSort = true; shouldShowFilter = true;" (mouseleave)="shouldShowSort = sortState !== 'none'; shouldShowFilter = !!filterState;" style="cursor: pointer;" (click)="getSortState()">
 *     First Name
 *     <span *ngIf="filterState">({{filterState}})</span>
 *     <rs-icon (click)="showShowFilter = true" [style.opacity]="!filterState ? .5 : 1" [rsMenuTrigger]="abc" style="position: absolute; margin-top: -4px;" *ngIf="shouldShowFilter">filter</rs-icon>
 *     <rs-icon [style.opacity]="sortState === 'none' ? .5 : 1" style="position: absolute; margin-top: -4px; margin-left: 32px;" *ngIf="shouldShowSort">{{sortState !== 'des' ? 'down' : 'up'}}</rs-icon>
 *   <rs-menu #abc baseZIndex="9999999" allowTyping>
 *  <rs-input label="filter" (click)="$event.stopPropagation()" (change)="filterState=$event.target.value; abc.remove(); filterIt()" style="padding: 16px">
 *  </rs-input>
 * </rs-menu></th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="phone">
 *   <th rs-header-cell *rsHeaderCellDef> Phone </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.phone}} </td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'phone']; sticky: true"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'phone'];"></tr>
 * </table>
 * </div>
 * @example
 * <!-- rs-doc {link: 'Double Header', data: { source: [{first: 'a', last: 'b', phone: '111-111-1111'}, {first: 'b', last: 'c', phone: '121-111-1111'}, {first: 'c', last: 'd', phone: '121-111-1111'}, {first: 'd', last: 'e', phone: '121-111-1111'}, {first: 'e', last: 'f', phone: '121-111-1111'}, {first: 'f', last: 'g', phone: '121-111-1111'}, {first: 'g', last: 'h', phone: '121-111-1111'}, {first: 'h', last: 'i', phone: '121-111-1111'}, {first: 'i', last: 'j', phone: '121-111-1111'}, {first: 'j', last: 'k', phone: '121-111-1111'}, {first: 'k', last: 'l', phone: '121-111-1111'}, {first: 'l', last: 'm', phone: '121-111-1111'}, {first: 'm', last: 'n', phone: '121-111-1111'}, {first: 'n', last: 'o', phone: '121-111-1111'}]}} -->
 * <div style="height: 400px; overflow: auto;">
 * <table style="width: 100%" rs-table [dataSource]="source">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef>
 *     First Name
 *   </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="index">
 *   <th rs-header-cell *rsHeaderCellDef> Index </th>
 *   <td rs-cell *rsCellDef="let i = index"> {{i}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="phone">
 *   <th rs-header-cell *rsHeaderCellDef> Phone </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.phone}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="top-1">
 *   <th rs-header-cell *rsHeaderCellDef colspan="2" style="text-align: center;"> Name </th>
 *  </ng-container>
 * <ng-container rsColumnDef="top-2">
 *   <th rs-header-cell *rsHeaderCellDef> Contact </th>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['top-1', 'top-2']"></tr>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'index', 'phone']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'index', 'phone'];"></tr>
 * </table>
 * </div>
 */
class HeaderRowComponent extends CdkHeaderRow {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: HeaderRowComponent, isStandalone: true, selector: "rs-header-row, tr[rs-header-row]", host: { attributes: { "role": "row" }, classAttribute: "rs-header-row" }, providers: [{ provide: CdkHeaderRow, useExisting: HeaderRowComponent }], exportAs: ["rsHeaderRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "ngmodule", type: CdkTableModule }, { kind: "directive", type: i1.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'rs-header-row, tr[rs-header-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'rs-header-row',
                        role: 'row',
                    },
                    // See note on CdkTable for explanation on why this uses the default change detection strategy.
                    // eslint-disable-next-line
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rsHeaderRow',
                    providers: [{ provide: CdkHeaderRow, useExisting: HeaderRowComponent }],
                    standalone: true,
                    imports: [CdkTableModule],
                }]
        }] });
/**
 * Footer template
 *
 * @description container that contains the cell outlet. Adds the right class and role.
 * @example
 * <!-- rs-doc {link: 'Example inside a card with pagnator in footer '} -->
 * <rs-card fullContent>
 * <div style="display: flex; align-items: center; padding: 30px 10px;">
 *  <rs-input label="item 1" style="flex: 1; margin: 0 10px;"></rs-input>
 *  <rs-input label="item 2" style="flex: 1; margin: 0 10px;"></rs-input>
 *  <rs-input label="item 3" style="flex: 1; margin: 0 10px;"></rs-input>
 *  <rs-input label="item 4" style="flex: 1; margin: 0 10px;"></rs-input>
 *  <button rs-raised-button style="margin-top: 8px;">Search</button>
 * </div>
 * <table style="width: 100%; padding-bottom: 2px;" rs-table [dataSource]="[{first: 'brandon', last: 'staley'}, {first: 'moira', last: 'rose'}, {first: 'david', last: 'rose'}, {first: 'alexis', last: 'rose'}, {first: 'johnny', last: 'rose'}]">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *   <td rs-footer-cell *rsFooterCellDef colspan="2"><rs-paginator color="basic" [length]="5" pageSize="10"></rs-paginator></td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *  </ng-container>
 * <ng-container rsColumnDef="action">
 *   <th rs-header-cell *rsHeaderCellDef style="width: 20px;"></th>
 *   <td rs-cell *rsCellDef="let element" style="width: 20px;">
 *  <svg [rsMenuTrigger]="abc" viewBox="0 0 24 24" fill="#000"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
 *  </td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'action']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'action'];"></tr>
 *  <tr rs-footer-row *rsFooterRowDef="['first']"></tr>
 * </table>
 * <rs-menu #abc>
 *  <button rs-menu-item>Testing</button>
 *  <button rs-menu-item>Testing 2</button>
 * </rs-menu>
 * </rs-card>
 * @example
 * <!-- rs-doc {link: 'Example with sticky footer'} -->
 * <div style="height: 400px; overflow: auto;">
 * <table style="width: 600px" rs-table [dataSource]="[{first: 'a', last: 'b', phone: '111-111-1111'}, {first: 'b', last: 'c', phone: '121-111-1111'}, {first: 'c', last: 'd', phone: '121-111-1111'}, {first: 'd', last: 'e', phone: '121-111-1111'}, {first: 'e', last: 'f', phone: '121-111-1111'}, {first: 'f', last: 'g', phone: '121-111-1111'}, {first: 'g', last: 'h', phone: '121-111-1111'}, {first: 'h', last: 'i', phone: '121-111-1111'}, {first: 'i', last: 'j', phone: '121-111-1111'}, {first: 'j', last: 'k', phone: '121-111-1111'}, {first: 'k', last: 'l', phone: '121-111-1111'}, {first: 'l', last: 'm', phone: '121-111-1111'}, {first: 'm', last: 'n', phone: '121-111-1111'}, {first: 'n', last: 'o', phone: '121-111-1111'}]">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 * <td rs-footer-cell *rsFooterCellDef> First Name </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 * <td rs-footer-cell *rsFooterCellDef> Last Name </td>
 *  </ng-container>
 * <ng-container rsColumnDef="phone">
 *   <th rs-header-cell *rsHeaderCellDef> Phone </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.phone}} </td>
 * <td rs-footer-cell *rsFooterCellDef>Phone</td>
 *  </ng-container>
 * <ng-container rsColumnDef="action">
 *   <th rs-header-cell *rsHeaderCellDef style="width: 20px;"></th>
 *   <td rs-cell *rsCellDef="let element" style="width: 20px;">
 *  <svg viewBox="0 0 24 24" fill="#000"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
 *  </td>
 *  <td rs-footer-cell *rsFooterCellDef></td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last', 'phone', 'last', 'phone', 'action']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last', 'phone', 'last', 'phone', 'action'];"></tr>
 *  <tr rs-footer-row *rsFooterRowDef="['first', 'last', 'phone', 'last', 'phone', 'action']; sticky: true"></tr>
 * </table>
 * </div>
 */
class FooterRowComponent extends CdkFooterRow {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: FooterRowComponent, isStandalone: true, selector: "rs-footer-row, tr[rs-footer-row]", host: { attributes: { "role": "row" }, classAttribute: "rs-footer-row" }, providers: [{ provide: CdkFooterRow, useExisting: FooterRowComponent }], exportAs: ["rsFooterRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "ngmodule", type: CdkTableModule }, { kind: "directive", type: i1.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FooterRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'rs-footer-row, tr[rs-footer-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'rs-footer-row',
                        role: 'row',
                    },
                    // See note on CdkTable for explanation on why this uses the default change detection strategy.
                    // eslint-disable-next-line
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rsFooterRow',
                    providers: [{ provide: CdkFooterRow, useExisting: FooterRowComponent }],
                    standalone: true,
                    imports: [CdkTableModule],
                }]
        }] });
/**
 * Data row template
 *
 * @description container that contains the cell outlet. Adds the right class and role.
 * @example
 * <!-- rs-doc {link: 'Multiple row definitions', data: { when: (function(i, e){ return !!(this.openMap && this.openMap[e.first]); }), source: [{first: 'a', last: 'b', phone: '111-111-1111'}, {first: 'b', last: 'c', phone: '121-111-1111'}, {first: 'c', last: 'd', phone: '121-111-1111'}, {first: 'd', last: 'e', phone: '121-111-1111'}, {first: 'e', last: 'f', phone: '121-111-1111'}, {first: 'f', last: 'g', phone: '121-111-1111'}, {first: 'g', last: 'h', phone: '121-111-1111'}, {first: 'h', last: 'i', phone: '121-111-1111'}, {first: 'i', last: 'j', phone: '121-111-1111'}, {first: 'j', last: 'k', phone: '121-111-1111'}, {first: 'k', last: 'l', phone: '121-111-1111'}, {first: 'l', last: 'm', phone: '121-111-1111'}, {first: 'm', last: 'n', phone: '121-111-1111'}, {first: 'n', last: 'o', phone: '121-111-1111'}], newSource: (function(){ return [...this.source];}) }} -->
 *  <div style="height: 400px; overflow: auto;">
 *   <table multiTemplateDataRows style="width: 100%" rs-table [dataSource]="source">
 *  <ng-container rsColumnDef="expand">
 *     <th rs-header-cell *rsHeaderCellDef>&nbsp;</th>
 *     <td rs-cell *rsCellDef="let element" style="width: 32px">
 *      <svg height="24px" width="24px" viewBox="0 0 24 24" fill="#000" *ngIf="openMap && openMap[element.first]" (click)="openMap[element.first] = false; source = newSource()">
 *        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
 *      </svg>
 *      <svg height="24px" width="24px" viewBox="0 0 24 24" fill="#000" *ngIf="!openMap || !openMap[element.first]" (click)="openMap = (openMap ? openMap : {}); openMap[element.first] = true; source = newSource()">
 *        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
 *      </svg>
 *     </td>
 *    </ng-container>
 *    <ng-container rsColumnDef="first">
 *     <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *     <td rs-cell *rsCellDef="let element">
 *      {{element.first}}
 *     </td>
 *    </ng-container>
 *    <ng-container rsColumnDef="last">
 *     <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *     <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *    </ng-container>
 *    <ng-container rsColumnDef="expanded">
 *     <td rs-cell *rsCellDef="let element" colspan="3">
 *      <table style="width: 100%" rs-table [dataSource]="[element]">
 *      <ng-container rsColumnDef="phone">
 *        <th rs-header-cell *rsHeaderCellDef> Phone </th>
 *        <td rs-cell *rsCellDef="let e"> {{e.phone}} </td>
 *       </ng-container>
 *       <tr rs-header-row *rsHeaderRowDef="['phone'];"></tr>
 *       <tr rs-row *rsRowDef="let row; columns: ['phone'];"></tr>
 *      </table>
 *     </td>
 *    </ng-container>
 *    <tr rs-header-row *rsHeaderRowDef="['expand', 'first', 'last'];"></tr>
 *    <tr rs-row *rsRowDef="let row; columns: ['expand', 'first', 'last'];"></tr>
 *    <tr rs-row *rsRowDef="let element; columns: ['expanded']; when: when"></tr>
 *  </table>
 * </div>
 */
class RowComponent extends CdkRow {
    constructor() {
        super(...arguments);
        /**
         * *rsRowDef.when
         *
         * @type {(index: number, rowData: T) => boolean}
         * @description Function that should return true if this row template should be used for the provided index and row data. If left undefined, this row will be considered the default row template to use when no other when functions return true for the data. For every row, there must be at least one when function that passes or an undefined to default.
         * @kind Input
         */
        this.__doc_only_when = undefined;
        /**
         * *rsRowDef.columns
         *
         * @type {string[]}
         * @description The columns to be displayed on this row.
         * @kind Input
         */
        this.__doc_only_columns = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: RowComponent, isStandalone: true, selector: "rs-row, tr[rs-row]", host: { attributes: { "role": "row" }, classAttribute: "rs-row" }, providers: [{ provide: CdkRow, useExisting: RowComponent }], exportAs: ["rsRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "ngmodule", type: CdkTableModule }, { kind: "directive", type: i1.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'rs-row, tr[rs-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'rs-row',
                        role: 'row',
                    },
                    // See note on CdkTable for explanation on why this uses the default change detection strategy.
                    // eslint-disable-next-line
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rsRow',
                    providers: [{ provide: CdkRow, useExisting: RowComponent }],
                    standalone: true,
                    imports: [CdkTableModule],
                }]
        }] });
/**
 * No Data Row Template
 *
 * @description row that can be used to display a message when no data is shown in the table
 * @example
 * <!-- rs-doc {link: 'example with no data'} -->
 * <table style="width: 100%" rs-table [dataSource]="[]">
 *  <ng-container rsColumnDef="first">
 *   <th rs-header-cell *rsHeaderCellDef> First Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.first}} </td>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <th rs-header-cell *rsHeaderCellDef> Last Name </th>
 *   <td rs-cell *rsCellDef="let element"> {{element.last}} </td>
 *  </ng-container>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'last']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'last'];"></tr>
 *  <tr class="rs-row" *rsNoDataRow>
 *    <td colspan="2" style="text-align: center; height: 150px" class="rs-cell" role="cell">
 *      <p>No Data Available</p>
 *      <p>Try updating the filters and searching</p>
 *    </td>
 *  </tr>
 * </table>
 * @example
 * <!-- rs-doc {link: 'example using flex with no data'} -->
 * <rs-table rs-table [dataSource]="[]">
 *  <ng-container rsColumnDef="first">
 *   <rs-header-cell style="flex: 1" *rsHeaderCellDef> First Name </rs-header-cell>
 *   <rs-cell style="flex: 1" *rsCellDef="let element"> {{element.first}} </rs-cell>
 *  </ng-container>
 *  <ng-container rsColumnDef="last">
 *   <rs-header-cell style="flex: 1" *rsHeaderCellDef> Last Name </rs-header-cell>
 *   <rs-cell style="flex: 1" *rsCellDef="let element"> {{element.last}} </rs-cell>
 *  </ng-container>
 *  <rs-header-row style="display:flex" *rsHeaderRowDef="['first', 'last']"></rs-header-row>
 *  <rs-row style="display:flex" *rsRowDef="let row; columns: ['first', 'last'];"></rs-row>
 *  <div class="rs-row" style="display:flex" *rsNoDataRow>
 *   <div style="flex:1; text-align: center; height: 150px" class="rs-cell" role="cell">
 *     <p>No Data Available</p>
 *     <p>Try updating the filters and searching</p>
 *   </div>
 * </div>
 * </rs-table>
 */
class NoDataRowComponent extends CdkNoDataRow {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NoDataRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: NoDataRowComponent, isStandalone: true, selector: "ng-template[rsNoDataRow]", providers: [{ provide: CdkNoDataRow, useExisting: NoDataRowComponent }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NoDataRowComponent, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[rsNoDataRow]',
                    providers: [{ provide: CdkNoDataRow, useExisting: NoDataRowComponent }],
                    standalone: true,
                }]
        }] });

/*
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Column
 *
 * @description Column that simply shows text content for the header and row cells. Assumes that the table
 * is using the native table implementation (`<table>`).
 *
 * By default, the name of this column will be the header text and data property accessor.
 * The header text can be overridden with the `headerText` input. Cell values can be overridden with
 * the `dataAccessor` input. Change the text justification to the start, center or end using the `justify`
 * input.
 * @example
 * <!-- rs-doc {link: 'Example with text-column'} -->
 * <table style="width: 100%" rs-table [dataSource]="[{first: 'brandon', centeredColumn: 'a', last: 'staley'}, {first: 'moira', centeredColumn: 'a', last: 'rose'}]">
 *  <rs-text-column name="first"></rs-text-column>
 *  <rs-text-column name="centeredColumn" justify="center"></rs-text-column>
 *  <rs-text-column name="last" headerText="Last"></rs-text-column>
 *  <tr rs-header-row *rsHeaderRowDef="['first', 'centeredColumn', 'last']"></tr>
 *  <tr rs-row *rsRowDef="let row; columns: ['first', 'centeredColumn', 'last'];"></tr>
 * </table>
 */
class TextColumnComponent extends CdkTextColumn {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TextColumnComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TextColumnComponent, isStandalone: true, selector: "rs-text-column", usesInheritance: true, ngImport: i0, template: `
    <ng-container rsColumnDef>
      <th rs-header-cell *rsHeaderCellDef [style.text-align]="justify">
        {{headerText}}
      </th>
      <td rs-cell *rsCellDef="let data" [style.text-align]="justify">
        {{dataAccessor(data, name)}}
      </td>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: ColumnDefComponent, selector: "[rsColumnDef]", inputs: ["sticky", "rsColumnDef"] }, { kind: "directive", type: HeaderCellDefComponent, selector: "[rsHeaderCellDef]" }, { kind: "directive", type: HeaderCellComponent, selector: "rs-header-cell, th[rs-header-cell]" }, { kind: "directive", type: CellDefComponent, selector: "[rsCellDef]" }, { kind: "directive", type: CellComponent, selector: "rs-cell, td[rs-cell]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TextColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'rs-text-column',
                    template: `
    <ng-container rsColumnDef>
      <th rs-header-cell *rsHeaderCellDef [style.text-align]="justify">
        {{headerText}}
      </th>
      <td rs-cell *rsCellDef="let data" [style.text-align]="justify">
        {{dataAccessor(data, name)}}
      </td>
    </ng-container>
  `,
                    encapsulation: ViewEncapsulation.None,
                    // Change detection is intentionally not set to OnPush. This component's template will be provided
                    // to the table to be inserted into its view. This is problepaic when change detection runs since
                    // the bindings in this template will be evaluated _after_ the table's view is evaluated, which
                    // mean's the template in the table's view will not have the updated value (and in fact will cause
                    // an ExpressionChangedAfterItHasBeenCheckedError).
                    // eslint-disable-next-line
                    changeDetection: ChangeDetectionStrategy.Default,
                    standalone: true,
                    imports: [
                        ColumnDefComponent,
                        HeaderCellDefComponent,
                        HeaderCellComponent,
                        CellDefComponent,
                        CellComponent,
                    ],
                }]
        }] });

/*
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: TableModule, imports: [CdkTableModule, // Table
            TableComponent,
            // Template defs
            HeaderCellDefComponent,
            HeaderRowDefComponent,
            ColumnDefComponent,
            CellDefComponent,
            RowDefComponent,
            FooterCellDefComponent,
            FooterRowDefComponent,
            // Cell directives
            HeaderCellComponent,
            CellComponent,
            FooterCellComponent,
            // Row directives
            HeaderRowComponent,
            RowComponent,
            FooterRowComponent,
            NoDataRowComponent,
            TextColumnComponent], exports: [TableComponent,
            // Template defs
            HeaderCellDefComponent,
            HeaderRowDefComponent,
            ColumnDefComponent,
            CellDefComponent,
            RowDefComponent,
            FooterCellDefComponent,
            FooterRowDefComponent,
            // Cell directives
            HeaderCellComponent,
            CellComponent,
            FooterCellComponent,
            // Row directives
            HeaderRowComponent,
            RowComponent,
            FooterRowComponent,
            NoDataRowComponent,
            TextColumnComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TableModule, imports: [CdkTableModule, // Table
            TableComponent,
            // Row directives
            HeaderRowComponent,
            RowComponent,
            FooterRowComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CdkTableModule, // Table
                        TableComponent,
                        // Template defs
                        HeaderCellDefComponent,
                        HeaderRowDefComponent,
                        ColumnDefComponent,
                        CellDefComponent,
                        RowDefComponent,
                        FooterCellDefComponent,
                        FooterRowDefComponent,
                        // Cell directives
                        HeaderCellComponent,
                        CellComponent,
                        FooterCellComponent,
                        // Row directives
                        HeaderRowComponent,
                        RowComponent,
                        FooterRowComponent,
                        NoDataRowComponent,
                        TextColumnComponent,
                    ],
                    exports: [
                        TableComponent,
                        // Template defs
                        HeaderCellDefComponent,
                        HeaderRowDefComponent,
                        ColumnDefComponent,
                        CellDefComponent,
                        RowDefComponent,
                        FooterCellDefComponent,
                        FooterRowDefComponent,
                        // Cell directives
                        HeaderCellComponent,
                        CellComponent,
                        FooterCellComponent,
                        // Row directives
                        HeaderRowComponent,
                        RowComponent,
                        FooterRowComponent,
                        NoDataRowComponent,
                        TextColumnComponent
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CellComponent, CellDefComponent, ColumnDefComponent, FooterCellComponent, FooterCellDefComponent, FooterRowComponent, FooterRowDefComponent, HeaderCellComponent, HeaderCellDefComponent, HeaderRowComponent, HeaderRowDefComponent, NoDataRowComponent, RowComponent, RowDefComponent, TableComponent, TableModule, TextColumnComponent };
